import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getTenantList = createAsyncThunk('/getTenantList', async () => {
  const response = await axios.get('/GetTenantList');
  return response.data;
});

export const getTenantMapData = createAsyncThunk('/GetTenantMapData', async () => {
  const response = await axios.get('/GetTenantMapData');
  return response.data;
});

export const getNotifications = createAsyncThunk(
  '/getInternalNotifications',
  async (employeeId) => {
     const response = await axios.get(
      `/getInternalNotifications/${employeeId}`
    );
    return response.data;
  }
);

export const readNotifications = createAsyncThunk(
  '/readInternalNotifications',
  async (employeeId,MaxId) => {
     const response = await axios.get(
      `/readInternalNotifications/${employeeId}/${MaxId}`
    );
    return response.data;
  }
);

export const getAddressTypes = createAsyncThunk('/GetAddressTypes', async () => {
  const response = await axios.get('/GetAddressTypes');
  return response.data;
});
export const getPhoneTypes = createAsyncThunk('/GetPhoneTypes', async () => {
  const response = await axios.get('/GetPhoneTypes');
  return response.data;
});
export const getCustomerTypes = createAsyncThunk('/GetCustomerType', async () => {
  const response = await axios.get('/GetCustomerType');
  return response.data;
});

export const getDefinedValues = createAsyncThunk('/GetDefinedValues', async () => {
  const response = await axios.get('/GetDefinedValues');
  return response.data;
});

export const getSurveyList = createAsyncThunk('/GetSurveyList', async () => {
  const response = await axios.get('/GetSurveyList');
  return response.data;
});

export const GetDefectType = createAsyncThunk('/GetDefectType', async () => {
  const response = await axios.get('/GetDefectType');
  return response.data;
})

export const getSurveyCondition = createAsyncThunk('/GetSiriusSurveyCondition', async () => {
  const response = await axios.get('/GetSiriusSurveyCondition');
  return response.data;
});

export const getSurveyConditionbyId = createAsyncThunk(
  '/GetSiriusSurveyConditionbyId',
  async (data) => {
     const response = await axios.get(
      `/GetSiriusSurveyConditionbyId/${data.Id}`
    );
    return response.data;
  }
);

export const getSurveyQuestionbyId = createAsyncThunk(
  '/GetSiriusSurveyQuestionbyId',
  async (data) => {
     const response = await axios.get(
      `/GetSiriusSurveyQuestionbyId/${data.Id}`
    );
    return response.data;
  }
);

export const getSurveyAnswerbyId = createAsyncThunk(
  '/GetSiriusSurveyAnswerbyId',
  async (data) => {
     const response = await axios.get(
      `/GetSiriusSurveyAnswerbyId/${data.Id}`
    );
    return response.data;
  }
);

export const getTenantVat = createAsyncThunk(
'/GetTenantVat',
  async (data) => {
    const response = await axiosHeadOffice.get(
      '/Common/GetTenantVat/' + data
    );
    return response.data;
  }
);

export const getTranslations = createAsyncThunk(
  '/GetTranslations',
  async (data) => {
    const response = await axiosHeadOffice.get(
      '/HeadOffice/GetTranslations/' + data
    );
    return response.data;
  }
);

export const setCatalogItem = createAsyncThunk(
  '/SetCatalogItem',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetCatalogItem',
      data
    );
    return response.data;
  }
);

export const getDefinedValuesDetails = createAsyncThunk(
  '/GetDefinedValuesDetails',
  async (id) => {
    const response = await axios.get(`/GetDefinedValuesDetails/${id}`);
    return response.data;
  }
);

export const setDefinedValue = createAsyncThunk(
  '/setDefinedValue',
  async (data) => {
     const response = await axios.get(
      `/setDefinedValue/${data.Id}/${data.Value}/${data.StartDate}`
    );
    return response.data;
  }
);

//really posting data with get ?... 
// export const AddSiriusQuestion = createAsyncThunk(
//   '/AddSiriusQuestion',
//   async (data) => {
//      const response = await axios.get(
//       `/AddSiriusQuestion/${data.Id}/${data.SiriusSurveyId}/${data.Description}/${data.AnswerType}`
//     );
//     return response.data;
//   }
// );
export const AddSiriusQuestion = createAsyncThunk(
  '/AddSiriusQuestion',
  async (data) => {
     const response = await axios.post(
      '/AddSiriusQuestion',
      data,{
        headers: {
            'Content-Type': 'application/json',
        }
    });
    return response.data;
  }
);


// export const AddSiriusAnswer = createAsyncThunk(
//   '/AddSiriusAnswer',
//   async (data) => {
//      const response = await axios.get(
//       `/AddSiriusAnswer/${data.Id}/${data.QuestionId}/${data.Description}`
//     );
//     return response.data;
//   }
// );

export const AddSiriusAnswer = createAsyncThunk(
  '/AddSiriusAnswer',
  async (data) => {
     const response = await axios.post(
      '/AddSiriusAnswer',
      data,{
        headers: {
            'Content-Type': 'application/json',
        }
    });
    return response.data;
  }
);


export const getIssues = createAsyncThunk('/getIssues', async () => {
  const response = await axios.get(`/GetIssues`);
  return response.data;
});

export const getAudienceType = createAsyncThunk('/getAudienceType', async () => {
  const response = await axios.get(`/GetAudienceType`);
  return response.data;
});


export const AddNewSurvey = createAsyncThunk(
  '/AddNewSurvey',
  async (data) => {
     const response = await axios.get(
      `/AddNewSurvey/${data.Title}/${data.Description}/${data.UserID}`
    );
    return response.data;
  }
);


export const getMobileStatusList = createAsyncThunk('/GetMobileStatusList', async () => {
  const response = await axios.get(`/GetMobileStatusList`);
  return response.data;
});

export const getCatalogStatuses = createAsyncThunk('/GetCatalogStatuses', async () => {
  const response = await axios.get(`/GetCatalogStatuses`);
  return response.data;
});


export const AddNewSurveyCondition = createAsyncThunk('/AddNewSurveyCondition', async (data) => {
  const response = await axiosHeadOffice.post(
    'Technician/AddNewSurveyCondition',
    data
  );
  return response.data;
});

export const getTenantsForEmployee = createAsyncThunk(
  '/GetTenantsForEmployee',
  async (data) => {
     const response = await axios.get(
      `/GetTenantsForEmployee/${data.EmployeeId}`
    );
    return response.data;
  }
);



// export const AddNewSurveyCondition = createAsyncThunk(
//   '/AddNewSurveyCondition',
//   async (data) => {
//      const response = await axios.get(
//       `/AddNewSurveyCondition/${data.SurveyId}/${data.WarrantyTypeId}/${data.DefectTypeId}/${data.AppTypeId}/${data.ProductGroup}/${data.WarrantyStartTime}/${data.WarrantyEndTime}/${data.Audience}`
//     );
//     return response.data;
//   }
// );

export const UpdateSurveyCondition = createAsyncThunk(
  '/UpdateSurveyCondition',
  async (data) => {
     const response = await axios.get(
      `/UpdateSurveyCondition/${data.Id}/${data.SurveyId}/${data.WarrantyTypeId}/${data.DefectTypeId}/${data.AppTypeId}/${data.ProductGroup}/${data.WarrantyStartTime}/${data.WarrantyEndTime}/${data.Audience}`
    );
    return response.data;
  }
);

export const DeleteSurveyCondition = createAsyncThunk(
  '/DeleteSurveyCondition',
  async (data) => {
     const response = await axios.get(
      `/DeleteSurveyCondition/${data.Id}`
    );
    return response.data;
  }
);
export const DeleteSurveyQuestion = createAsyncThunk(
  '/DeleteSurveyQuestion',
  async (data) => {
     const response = await axios.get(
      `/DeleteSurveyQuestion/${data.Id}`
    );
    return response.data;
  }
);


export const DeleteSurveyAnswer = createAsyncThunk(
  '/DeleteSurveyAnswer',
  async (data) => {
     const response = await axios.get(
      `/DeleteSurveyAnswer/${data.Id}`
    );
    return response.data;
  }
);

export const setTranslation = createAsyncThunk('/SetTranslation', async (data) => {
  const response = await axiosHeadOffice.post(
    '/HeadOffice/SetTranslation',
    data
  );
  return response.data;
});

const commonSlice = createSlice({
  name: 'common',
  initialState: {
    selectedItemId: 0,
    loading: false,
    success : false,
    error: '',
    Tenants: [],
    TenantMapData: [],
    AddressTypes: [],
    PhoneTypes: [],
    CustomerTypes: [],
    PriorityTypes: [],
    DefinedValues:[],
    DefinedValuesDetails:[],
    Notifications:[],
    UnReadedNotificaionLenght:0,
    ActiveTenant: 0
  },
  reducers: {
    changeselectedItemId(state, action) {
      state.selectedItemId = action.payload;
    },
    changeActiveTenant(state, action) {
      state.ActiveTenant = action.payload;
    },
    ReadAllNotifications(state){
      if(state.Notifications !== undefined && state.Notifications.length > 0)
    {
      state.Notifications = state.Notifications.map(n => {
        if (n.IsRead === false) {
          return { ...n, IsRead: true };
        }
        return n;
      });

      state.UnReadedNotificaionLenght = 0;
    }
    }
  },
  extraReducers: {
    [getTenantList.pending]: (state) => {
      state.loading = true;
    },
    [getTenantList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTenantList.fulfilled]: (state, action) => {
      state.Tenants = action.payload;
      state.loading = false;    },

    [getTenantMapData.pending]: (state) => {
      state.loading = true;

    },
    [getTenantMapData.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTenantMapData.fulfilled]: (state, action) => {
      state.TenantMapData = action.payload;
      state.loading = false;    },
    [getNotifications.pending]: (state) => {
      state.loading = true;

    },
    [getNotifications.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getNotifications.fulfilled]: (state, action) => {
      state.Notifications = action.payload;
      if(action.payload){
        const unreadItems = action.payload.filter(item => item.IsRead === false);
        state.UnReadedNotificaionLenght = unreadItems.length
      }
      
      state.loading = false;    },
    [readNotifications.pending]: (state) => {
      state.loading = true;
    },
    [readNotifications.rejected]: (state, action) => {
      state.loading = false;
    },
    [readNotifications.fulfilled]: (state, action) => {
      state.loading = false;    },
    [getTranslations.pending]: (state) => {
      state.loading = true;
     },
    [getTranslations.rejected]: (state, action) => {
      state.error = action.error;
      state.success=false;
      state.loading = false;
    },
    [getTranslations.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.success=true;
      state.loading = false;    
    },
    [setCatalogItem.pending]: (state) => {
      state.loading = true;
     },
    [setCatalogItem.rejected]: (state, action) => {
      state.error = action.error;
      state.success=false;
      state.loading = false;
    },
    [setCatalogItem.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.success=true;
      state.loading = false;    
    },
    [getAddressTypes.pending]: (state) => {
      state.loading = true;
      state.loading = false;
    },
    [getAddressTypes.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getAddressTypes.fulfilled]: (state, action) => {
      state.AddressTypes = action.payload;
      state.loading = false;    },
    [getPhoneTypes.pending]: (state) => {
      state.loading = true;
      state.loading = false;
    },
    [getPhoneTypes.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getPhoneTypes.fulfilled]: (state, action) => {
      state.PhoneTypes = action.payload;
      state.loading = false;    },
    [getCustomerTypes.pending]: (state) => {
      state.loading = true;
    },
    [getCustomerTypes.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getCustomerTypes.fulfilled]: (state, action) => {
      state.CustomerTypes = action.payload;
      state.loading = false;
    },
    [getDefinedValues.pending]: (state) => {
      state.loading = true;
    },
    [getDefinedValues.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getDefinedValues.fulfilled]: (state, action) => {
      state.DefinedValues = action.payload;
      state.loading = false;
    },
    [getDefinedValuesDetails.pending]: (state) => {
      state.loading = true;
    },
    [getDefinedValuesDetails.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getDefinedValuesDetails.fulfilled]: (state, action) => {
      state.DefinedValuesDetails = action.payload;
      state.loading = false;
    }
  }
});

export const commonActions = commonSlice.actions;

export default commonSlice;
